import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit';
import type {RootState} from '../redux/store';
import {fetchTransactionStatus} from '../api/payment.api';
// Define a type for the slice state

type PaymentState = {
  loading: boolean;
  transactionStatus: null | any;
  error: string;
};

type PaymentRequest = {
  //parameters: {
  //payload: {
  checksum: string;
  //};
  // accessToken: string;
  //};
};

type TxnTokenRequest = {
  orderId: string;
  amount: string;
  customerId: string;
};
// Define the initial state using that type
const initialState: PaymentState = {
  loading: false,
  transactionStatus: null,
  error: '',
};

export const getTransactionStatus = createAsyncThunk(
  'checkout/payment',
  async (checksum: string, thunkApi) => {
    return fetchTransactionStatus(checksum)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);

export const paymentSlice = createSlice({
  name: 'paymentSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetCouponState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(getTransactionStatus.pending, state => {
      state.loading = true;
    });
    builder.addCase(getTransactionStatus.fulfilled, (state, {payload}) => {
      state.transactionStatus = payload.data.data.body;
      state.loading = false;
    });
    builder.addCase(getTransactionStatus.rejected, (state, action) => {
      state.error = action.toString();
      state.loading = false;
    });
  },
});
export const {resetCouponState} = paymentSlice.actions;
// Other code such as selectors can use the imported `RootState` type

export const transactionStatus = (state: RootState): any | null =>
  state.paymentReducer.transactionStatus;

export default paymentSlice.reducer;
